import { Injectable } from "@angular/core";
import { DYService } from "../../networking/services/dynamic-yield/dynamic-yield.service";
import { SessionStorageManager } from '../session-storage/session-storage.manager';

@Injectable({
  providedIn: 'root',
})
export class  DynamicYieldManager{
  constructor(private dyService: DYService, private sesionStorageManager: SessionStorageManager){}

  setCityContextDY(city): void{
    const cityName = this.sesionStorageManager.get('city')?.name
    city = (city || cityName)?.replace(/ /g, '_');
    this.dyService.setCityContext(city);
  }

  getCookie(): void{
    this.dyService.setCookieDY();
  }
}